module.exports = __webpack_public_path__ + "img/variables.277fe729.svg";